import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setDragStateReducer = (state: EditorState, action: PayloadAction<EditorState['dragState']>) => {
  state.dragState = action.payload;
};

export default setDragStateReducer;
